import axios from 'axios'
import { Api } from 'types/api'

export const getErrorMessage = (err: unknown) => {
  let message = ''

  if (!err || !axios.isAxiosError(err)) return message

  const data = err.response?.data as Api.ErrorResponse

  // Check if err.response is defined before accessing properties
  if (data && data.errors) {
    message = data.errors.join(', ')
  } else {
    message = err.message || 'An error occurred'
  }

  return message
}
